export interface Client {
    almacen: string;
    calle: string;
    clmnc: string;
    clswb: string;
    codigo: number;
    codPostal: string;
    id: number;
    nif: string;
    nombre: string;
    observaciones: string;
}

export class ClientHelper {

    static create(): Client {
        return {
            almacen: '',
            calle: '',
            clmnc: '',
            clswb: '',
            codigo: 0,
            codPostal: '',
            id: 0,
            nif: '',
            nombre: '',
            observaciones: '',
        };
    }

    static transformFromAPI(apiData: Object) {
        const obj = ClientHelper.create();
        obj.almacen = apiData['ALMACEN'];
        obj.calle = apiData['CALLE'];
        obj.clmnc = apiData['CLMNC'];
        obj.clswb = apiData['CLSWB'];
        obj.codigo = apiData['CODIGO'];
        obj.codPostal = apiData['CODPOSTAL'];
        obj.id = apiData['ID'];
        obj.nif = apiData['NIF'];
        obj.nombre = apiData['NOMBRE'];
        obj.observaciones = (apiData['OBSERVACIONES']) ? apiData['OBSERVACIONES'].trim() : '';
        return obj;
    }
}
